module.exports = __webpack_public_path__ + "static/media/04_waterscapes-kelowna.bf43d207.jpg";